// Dashboard
// import DashboardIcon from "../assets/icons/dashboard.svg";
import DashboardActiveIcon from "../assets/icons/dashboard_orange.svg";
import DashboardIcon from "../assets/icons/dashboard-2.svg";

// Role List
// import RoleMngIcon from "../assets/icons/role_mangmnt.svg";
// import RoleMngActiveIcon from "../assets/icons/role_mangmnt_orange.svg";
// import RolesList from "../pages/containers/Roles-CRUD/RolesList";
// import RoleView from "../pages/containers/Roles-CRUD/RoleView";
// import RoleEdit from "../pages/containers/Roles-CRUD/RoleEdit";

//User Management
import UserMngIcon from "../assets/icons/user.svg";
import setup from "../assets/icons/master_setup.svg";
import UserMngActiveIcon from "../assets/icons/user_managemnt_orange.svg";
import reports from "../assets/icons/reports.svg";

// Permissions
import { PERMISSIONS } from "../constants/index";
// Product Catalog
import ProductCatalogIcon from "../assets/icons/product-icon.svg";
import ProductCatalogActiveIcon from "../assets/icons/product_catalog_orange.svg";
import ArrowSide from "../assets/icons/right_arrow.svg";
import ArrowSideActive from "../assets/icons/right_arrow_orange.svg";

// inventory Management
// import InventoryMngIcon from "../assets/icons/product_catalog.svg";
import InventoryMngActiveIcon from "../assets/icons/product_catalog_orange.svg";
import InventoryIcon from "../assets/icons/inventory-icon.svg";

// warehouse management
import WarehouseMngIcon from "../assets/icons/warehouse-icon.svg";
import WarehouseMngActiveIcon from "../assets/icons/warehouse_managemnt_orange.svg";

// Zone Management
// import ZoneMngIcon from "../assets/icons/zone_management.svg";
import ZoneMngActiveIcon from "../assets/icons/zone_management_orange.svg";
import ZoneIcon from "../assets/icons/zone-management-2.svg";

// Delivery Partner
// import PartnerMngIcon from "../assets/icons/delivery_partner.svg";
// import PartnerMngActiveIcon from "../assets/icons/delivery_partner_orange.svg";
// import DeliveryPartnerIcon from "../assets/icons/delivery-partner-2.svg";

// Store Management
// import StoreMngIcon from "../assets/icons/store_managemnt.svg";
// import StoreMngActiveIcon from "../assets/icons/store_managemnt_orange.svg";
// import StoreIcon from "../assets/icons/store-management-2.svg";

// Franchise Management
// import FranchiseMngIcon from "../assets/icons/franchise_managemnt.svg";
import FranchiseMngActiveIcon from "../assets/icons/franchise_managemnt_orange.svg";
import FranchiseIcon from "../assets/icons/franchise-management-2.svg";

// Shipping Management
// import ShippingIcon from "../assets/icons/shipping_management.svg";
import ShippingActiveIcon from "../assets/icons/shipping_management_orange.svg";
import ShippingManagementIcon from "../assets/icons/shipping-management-2.svg";

// Delivery Person Management
import DeliveryPersonIcon from "../assets/icons/delivery_person.svg";
import DeliveryPersonActiveIcon from "../assets/icons/delivery_person_orange.svg";

// Refill Management
// import RefillPartnerIcon from "../assets/icons/refill-management-2.svg";

// Retailers Management
// import RetailerIcon from "../assets/icons/Scales.svg";
// import RetailerIcon from "../assets/icons/scaleIcon.svg";

//Refill Plan
import RefillPlanIcon from "../assets/icons/refillPlanIcon.svg";

// Vending Machine
// import VendingMachineMngIcon from "../assets/icons/vending_machine_mangmnt.svg";
import VendingMachineMngActiveIcon from "../assets/icons/vending_machine_mangmnt_orange.svg";
import VendingMachineIcon from "../assets/icons/vending-machine-2.svg";
import EventModuleIcon from "../assets/icons/eventModule.svg";

// Procurement Managements Management
// import OrderManagementIcon from "../assets/icons/order_managemnt.svg";
import OrderManagementActiveIcon from "../assets/icons/order_managemnt_orange.svg";

// Sales Analytics
// import salesManagementIcon from "../assets/icons/sales_analytics.svg";
import salesManagementActiveIcon from "../assets/icons/sales_analytics_orange.svg";
import SalesAnalyticsIcon from "../assets/icons/sales-analytics-2.svg";
import SalePartnerIcon from "../assets/images/partner.png";
import TechnicianTransactionIcon from "../assets/images/activity-log-icon.png";
// Offers Management
// import offerManagementIcon from "../assets/icons/offer_tag.svg";
import offerManagementActiveIcon from "../assets/icons/offer_tag_orange.svg";
import PurchaseOrderManagementIcon from "../assets/icons/purchase-icon.svg";
import PurchaseOrderManagementActiveIcon from "../assets/icons/order_managemnt_orange.svg";
import { APP_ROUTES } from "../constants/appRoutes";
import OfferIcon from "../assets/icons/offer-management-2.svg";
// import CsvReportIcon from "../assets/images/csvReport.png";

//Supplier Management
import SupplierManagementIcon from "../assets/icons/supplier-icon.svg";
import SupplierManagementActiveIcon from "../assets/icons/supplier_management_orange.svg";

// Transaction Management
import TransactionManagementIcon from "../assets/icons/transaction-management-2.svg";

import ActionHistorySVG from "../assets/icons/action_history.svg";

import React from "react";
import CashCollectionView from "pages/containers/CashCollection/CashCollectionView";
import MaterialTransferManageView from "pages/containers/Warehouse-CRUD/MaterialTransfer/MaterialTransferManageView";

// import TallyInventoryModify from "../pages/containers/Warehouse-CRUD/TallyInventory/TallyInventoryModify";
// import { API_ROUTES } from "constants/apiRoutes";

const MachineEventLog = React.lazy(
  () => import("pages/containers/Machines-CRUD/MachineEventLog"),
);

const GenerateReport = React.lazy(
  () => import("pages/containers/Reports-CRUD/GenerateReport"),
);
const MasterDataSetup = React.lazy(
  () => import("pages/containers/SystemAuditor/MasterDataSetup"),
);

const SystemAuditorVendingMachineList = React.lazy(
  () => import("pages/containers/SystemAuditor/VmList"),
);
const RefillTrigger = React.lazy(
  () => import("pages/containers/SystemAuditor/RefillTrigger"),
);
const IncidentTrigger = React.lazy(
  () => import("pages/containers/SystemAuditor/IncidentTrigger"),
);
const PlanogramAdherence = React.lazy(
  () => import("pages/containers/SystemAuditor/PlanogramAdherence"),
);
// Advertisement Management
const ReportsList = React.lazy(
  () => import("pages/containers/Reports-CRUD/ReportsList"),
);
const RecurringReports = React.lazy(
  () => import("pages/containers/Reports-CRUD/RecurringReports"),
);
const AdvertisementList = React.lazy(
  () => import("../pages/containers/Advertisement-CRUD/AdvertisementList"),
);

const AddAdvertisement = React.lazy(
  () => import("pages/containers/Advertisement-CRUD/AddAdvertisement"),
);

const AdvertisementView = React.lazy(
  () => import("../pages/containers/Advertisement-CRUD/AdvertisementView"),
);

const AddUser = React.lazy(
  () => import("../pages/containers/Users-CRUD/AddUser"),
);

const AddWarehouseManager = React.lazy(
  () => import("../pages/containers/Users-CRUD/AddWarehouseManager"),
);

const ViewWarehouseManager = React.lazy(
  () => import("../pages/containers/Users-CRUD/WarehouseManagerOverview"),
);

const WarehouseStock = React.lazy(
  () => import("../pages/containers/Warehouse-CRUD/WarehouseStock"),
);

const TallyInventoryModify = React.lazy(
  () =>
    import("../pages/containers/Warehouse-CRUD/TallyInventory/TallyInventoryModify"),
);

const PackageTransferView = React.lazy(
  () =>
    import("../pages/containers/PackageTransfer-CRUD/PackageTransferOverview"),
);

const KitTransferView = React.lazy(
  () => import("../pages/containers/KitTransfer-CRUD/KitTransferOverview"),
);

const SaleOrderView = React.lazy(
  () => import("../pages/containers/SaleOrder/SaleOrderView"),
);

const LinkNewRefillPartner = React.lazy(
  () =>
    import("../pages/containers/Warehouse-CRUD/LinkRefillPartner/LinkRefillPartner"),
);

const EditLinkRefillPartner = React.lazy(
  () =>
    import("../pages/containers/Warehouse-CRUD/LinkRefillPartner/EditLinkRefillPartner"),
);

const LinkNewVM = React.lazy(
  () =>
    import("../pages/containers/RefillPartner-CRUD/LinkVendingMachines/LinkVM"),
);

const EditLinkVM = React.lazy(
  () =>
    import("../pages/containers/RefillPartner-CRUD/LinkVendingMachines/EditLinkVM"),
);

const LinkNewWarehouse = React.lazy(
  () =>
    import("../pages/containers/RefillPartner-CRUD/LinkWarehouse/LinkWarehouse"),
);

const EditLinkWarehouse = React.lazy(
  () =>
    import("../pages/containers/RefillPartner-CRUD/LinkWarehouse/EditLinkWarehouse"),
);

const LinkNewVehicle = React.lazy(
  () =>
    import("../pages/containers/RefillPartner-CRUD/LinkVehicle/LinkVehicle"),
);

const EditLinkVehicle = React.lazy(
  () =>
    import("../pages/containers/RefillPartner-CRUD/LinkVehicle/EditLinkVehicle"),
);

const LinkNewWarehouseManager = React.lazy(
  () =>
    import("../pages/containers/Warehouse-CRUD/LinkWarehouseManager/LinkWarehouseManager"),
);

const EditLinkWarehouseManager = React.lazy(
  () =>
    import("../pages/containers/Warehouse-CRUD/LinkWarehouseManager/EditLinkWarehouseManager"),
);

const LinkWarehouseforWM = React.lazy(
  () => import("../pages/containers/Users-CRUD/LinkWarehouse/LinkWarehouse"),
);

const EditLinkWarehouseforWM = React.lazy(
  () =>
    import("../pages/containers/Users-CRUD/LinkWarehouse/EditLinkWarehouse"),
);

const LinkRefillerPermission = React.lazy(
  () =>
    import("../pages/containers/RefillPartner-CRUD/LinkPermission/LinkPermission"),
);
const LinkRefillerNotifications = React.lazy(
  () =>
    import("../pages/containers/RefillPartner-CRUD/LinkNotifications/LinkNotifications"),
);

const EditLinkRefillerPermission = React.lazy(
  () =>
    import("../pages/containers/RefillPartner-CRUD/LinkPermission/EditLinkPermission"),
);

const UserView = React.lazy(
  () => import("../pages/containers/Users-CRUD/UserView"),
);
const ProductView = React.lazy(
  () => import("../pages/containers/Product-CRUD/ProductView"),
);
const AddProduct = React.lazy(
  () => import("../pages/containers/Product-CRUD/AddProduct"),
);
const ProductsRequested = React.lazy(
  () => import("../pages/containers/Product-CRUD/ProductsRequested"),
);
const AddRequestProduct = React.lazy(
  () => import("../pages/containers/Product-CRUD/AddRequestProduct"),
);
const ViewRequestProduct = React.lazy(
  () => import("../pages/containers/Product-CRUD/RequestProductOverview"),
);

// const ProductCategoryView = React.lazy(() =>
//   import("../pages/containers/ProductCategory-CRUD/ProductCategoryView")
// );
// const ProductBrandView = React.lazy(() =>
//   import("../pages/containers/ProductBrand-CRUD/ProductBrandView")
// );
// const ProductUnitView = React.lazy(() =>
//   import("../pages/containers/ProductUnit-CRUD/ProductUnitView")
// );
// const ProductPackagingView = React.lazy(() =>
//   import("../pages/containers/ProductPackaging-CRUD/ProductPackagingView")
// );
const AddWarehouse = React.lazy(
  () => import("../pages/containers/Warehouse-CRUD/AddWarehouse"),
);
const WarehouseView = React.lazy(
  () => import("../pages/containers/Warehouse-CRUD/WarehouseView"),
);

// const ReportList = React.lazy(() => import("../pages/containers/Report"));

// Store and VM Return Orders Overview
const WarehouseStoreReturnOrdersView = React.lazy(
  () =>
    import("../pages/containers/Warehouse-CRUD/WarehouseStoreReturnOrdersView"),
);
const WarehouseVMReturnOrdersView = React.lazy(
  () =>
    import("../pages/containers/Warehouse-CRUD/WarehouseVMReturnOrdersView"),
);

const AddZone = React.lazy(
  () => import("../pages/containers/Zone-CRUD/AddZone"),
);
const ZoneView = React.lazy(
  () => import("../pages/containers/Zone-CRUD/ZoneView"),
);
const AddDeliveryPartner = React.lazy(
  () => import("../pages/containers/DeliveryPartner-CRUD/AddDeliveryPartner"),
);
const DeliveryPartnerView = React.lazy(
  () => import("../pages/containers/DeliveryPartner-CRUD/DeliveryPartnerView"),
);
const StoreList = React.lazy(
  () => import("../pages/containers/Store-CRUD/StoreList"),
);
const AddStore = React.lazy(
  () => import("../pages/containers/Store-CRUD/AddStore"),
);
const StoreView = React.lazy(
  () => import("../pages/containers/Store-CRUD/StoreView"),
);

const AddStoreReturn = React.lazy(
  () => import("../pages/containers/Store-CRUD/AddStoreReturn"),
);
const StoreInventoryList = React.lazy(
  () => import("../pages/containers/Inventory-CRUD/StoreInventoryList"),
);
const AddFranchise = React.lazy(
  () => import("../pages/containers/Franchise-CRUD/AddFranchise"),
);
const FranchiseView = React.lazy(
  () => import("../pages/containers/Franchise-CRUD/FranchiseView"),
);
const ShippingView = React.lazy(
  () => import("../pages/containers/Shipping-CRUD/ShippingView"),
);
const ShippingManageView = React.lazy(
  () => import("../pages/containers/Shipping-CRUD/ShippingManageView"),
);
const AddShipping = React.lazy(
  () => import("../pages/containers/Shipping-CRUD/AddShipping"),
);
const AddDeliveryPerson = React.lazy(
  () => import("../pages/containers/DeliveryPerson-CRUD/AddDeliveryPerson"),
);
const DeliveryPersonView = React.lazy(
  () => import("../pages/containers/DeliveryPerson-CRUD/DeliveryPersonView"),
);

const AddRefillPartner = React.lazy(
  () => import("../pages/containers/RefillPartner-CRUD/AddRefillPartner"),
);

const RefillPartnerList = React.lazy(
  () => import("../pages/containers/RefillPartner-CRUD/RefillPartnerList"),
);

const RefillPartnerView = React.lazy(
  () => import("../pages/containers/RefillPartner-CRUD/RefillPartnerView"),
);

const RefillManagementList = React.lazy(
  () =>
    import("../pages/containers/RefillManagement-CRUD/RefillManagementList"),
);
const AddRefillManagement = React.lazy(
  () => import("../pages/containers/RefillManagement-CRUD/AddRefillManagement"),
);
const RefillManagementView = React.lazy(
  () =>
    import("../pages/containers/RefillManagement-CRUD/RefillManagementView"),
);
const TechnicianPartnerList = React.lazy(
  () => import("../pages/containers/Technician-CRUD/TechnicianPartnerList"),
);
const AddTechnicalPartner = React.lazy(
  () => import("../pages/containers/Technician-CRUD/AddTechnicianPartner"),
);
const TechnicianPartnerView = React.lazy(
  () => import("../pages/containers/Technician-CRUD/TechnicianPartnerView"),
);
const TechnicianAddNewWarehouse = React.lazy(
  () =>
    import("../pages/containers/Technician-CRUD/LinkWarehouse/LinkWarehouse"),
);

const TechnicianLinkNewVM = React.lazy(
  () =>
    import("../pages/containers/Technician-CRUD/LinkVendingMachines/LinkVM"),
);

const TechnicianEditLinkVM = React.lazy(
  () =>
    import("../pages/containers/Technician-CRUD/LinkVendingMachines/EditLinkVM"),
);

const TechnicianLinkPermission = React.lazy(
  () =>
    import("../pages/containers/Technician-CRUD/LinkPermission/LinkPermission"),
);
const TechnicianEditLinkPermission = React.lazy(
  () =>
    import("../pages/containers/Technician-CRUD/LinkPermission/EditLinkPermission"),
);

const TechnicianEditLinkNotification = React.lazy(
  () =>
    import("../pages/containers/Technician-CRUD/LinkNotifications/LinkNotifications"),
);
const TechnicianTransactionList = React.lazy(
  () => import("../pages/containers/Technician-CRUD/TechnicianTransaction"),
);
const VendingMachineView = React.lazy(
  () => import("../pages/containers/VendingMachine-CRUD/VendingMachineView"),
);
const DeletedVendingMachineView = React.lazy(
  () =>
    import("../pages/containers/VendingMachine-CRUD/DeletedVendingMachineView"),
);
const CreateVendingMachine = React.lazy(
  () =>
    import("../pages/containers/VendingMachine-CRUD/ConfigureVendingMachine"),
);
const VendingMachineSnapshot = React.lazy(
  () =>
    import("../pages/containers/VendingMachine-CRUD/VendingMachineSnapshot"),
);
// const OrderView = React.lazy(() =>
//   import("../pages/containers/Order-CRUD/OrderView")
// );
const VendingMachineFeedback = React.lazy(
  () =>
    import("../pages/containers/VendingMachine-CRUD/VendingMachineFeedback"),
);
const ProductFeedback = React.lazy(
  () => import("../pages/containers/Product-CRUD/ProductFeedback"),
);
const NotificationList = React.lazy(
  () => import("../pages/containers/Notifications/index"),
);
const AddCoupon = React.lazy(
  () => import("../pages/containers/Offer-CRUD/AddCoupon"),
);
const ViewCoupon = React.lazy(
  () => import("../pages/containers/Offer-CRUD/ViewCoupon"),
);
const DiscountView = React.lazy(
  () => import("../pages/containers/Offer-CRUD/DiscountView"),
);
const OfferHistory = React.lazy(
  () => import("../pages/containers/Offer-CRUD/OfferHistory"),
);
const SubOfferHistory = React.lazy(
  () => import("../pages/containers/Offer-CRUD/SubOfferHistory"),
);
const AddDiscount = React.lazy(
  () => import("../pages/containers/Offer-CRUD/AddDiscount"),
);
const StoreVmsReturnsOverView = React.lazy(
  () => import("../pages/containers/Store-CRUD/StoreVmsReturnsOverView"),
);
const StoreStoreReturnsOverView = React.lazy(
  () => import("../pages/containers/Store-CRUD/StoreStoreReturnOverview"),
);
const TallyOrderOverview = React.lazy(
  () => import("../pages/containers/RefillManagement-CRUD/TallyOrderOverview"),
);
const CashOrderOverview = React.lazy(
  () => import("../pages/containers/RefillManagement-CRUD/CashOrderOverview"),
);
const TopUpOverview = React.lazy(
  () => import("../pages/containers/RefillManagement-CRUD/TopUpOverview"),
);
const KitTransferModify = React.lazy(
  () =>
    import("../pages/containers/KitTransfer-CRUD/KitTransferModify/KitTransferModify"),
);
const PackageTransferModify = React.lazy(
  () =>
    import("../pages/containers/PackageTransfer-CRUD/PackageTransferModify/PackageTransferModify"),
);
const PurchaseOrderModify = React.lazy(
  () =>
    import("../pages/containers/PurchaseOrderManagement/PurchaseOrderModify/PurchaseOrderModify"),
);
const AddPurchaseReturn = React.lazy(
  () =>
    import("../pages/containers/PurchaseOrderManagement/AddPurchaseReturn/AddPurchaseReturn"),
);
const MaterialTransferEdit = React.lazy(
  () => import("../pages/containers/Shipping-CRUD/AddShipping"),
);
const WarehouseOrderList = React.lazy(
  () => import("../pages/containers/Warehouse-CRUD/WarehouseOrderList"),
);
const SupplierModify = React.lazy(
  () =>
    import("../pages/containers/SupplierManagement/SupplierModify/SupplierModify"),
);
const SupplierReturnOverview = React.lazy(
  () =>
    import("../pages/containers/SupplierManagement/SupplierReturn/SupplierReturnOverview"),
);
const TallyInventoryOverView = React.lazy(
  () =>
    import("../pages/containers/Warehouse-CRUD/TallyInventory/TallyInventoryOverView"),
);
const MaterialTransferOverview = React.lazy(
  () =>
    import("../pages/containers/Warehouse-CRUD/MaterialTransfer/MaterialTransferOverview"),
);
const DiscardedBinOverview = React.lazy(
  () =>
    import("../pages/containers/Warehouse-CRUD/DiscardedBin/DiscardedBinOverview"),
);

const SupplierView = React.lazy(
  () =>
    import("../pages/containers/SupplierManagement/SupplierView/SupplierView"),
);
const PurchaseOrderView = React.lazy(
  () =>
    import("../pages/containers/PurchaseOrderManagement/PurchaseOrderView/PurchaseOrderView"),
);
const PurchaseReturnView = React.lazy(
  () =>
    import("../pages/containers/PurchaseOrderManagement/PurchaseReturnView/PurchaseReturnView"),
);
const PurchaseOrderManageView = React.lazy(
  () =>
    import("../pages/containers/PurchaseOrderManagement/PurchaseOrderManageView/PurchaseOrderManageView"),
);
const Dashboard = React.lazy(() => import("../pages/containers/Dashboard"));
const UsersList = React.lazy(
  () => import("../pages/containers/Users-CRUD/UsersList"),
);
const RetailersList = React.lazy(
  () => import("../pages/containers/Retailers-CRUD/RetailersList"),
);
const ProductList = React.lazy(
  () => import("../pages/containers/Product-CRUD/ProductList"),
);
const ProductCategoryList = React.lazy(
  () => import("../pages/containers/ProductCategory-CRUD/ProductCategoryList"),
);
const ProductBrandList = React.lazy(
  () => import("../pages/containers/ProductBrand-CRUD/ProductBrandList"),
);
const ProductUnitList = React.lazy(
  () => import("../pages/containers/ProductUnit-CRUD/ProductUnitList"),
);
const ProductPackagingList = React.lazy(
  () =>
    import("../pages/containers/ProductPackaging-CRUD/ProductPackagingList"),
);
const SyncProductList = React.lazy(
  () =>
    import("../pages/containers/Product-CRUD/SyncProductList/SyncProductList"),
);
const NewProductList = React.lazy(
  () =>
    import("../pages/containers/Product-CRUD/NewProductList/NewProductList"),
);
const SyncBrandCatalogues = React.lazy(
  () =>
    import(
      "../pages/containers/Product-CRUD/SyncProductList/SyncBrandCatalogues"
    ),
);
const SyncCatalogueProducts = React.lazy(
  () =>
    import(
      "../pages/containers/Product-CRUD/SyncProductList/SyncCatalogueProducts"
    ),
);
const SupplierList = React.lazy(
  () =>
    import("../pages/containers/SupplierManagement/SupplierList/SupplierList"),
);
const PurchaseOrderList = React.lazy(
  () =>
    import("../pages/containers/PurchaseOrderManagement/PurchaseOrderList/PurchaseOrderList"),
);
const WarehouseList = React.lazy(
  () => import("../pages/containers/Warehouse-CRUD/WarehouseList"),
);
const InventoryList = React.lazy(
  () => import("../pages/containers/Inventory-CRUD/InventoryList"),
);
const ZoneList = React.lazy(
  () => import("../pages/containers/Zone-CRUD/ZoneList"),
);
const DeliveryPersonList = React.lazy(
  () => import("../pages/containers/DeliveryPerson-CRUD/DeliveryPersonList"),
);
const DeliveryPartnerList = React.lazy(
  () => import("../pages/containers/DeliveryPartner-CRUD/DeliveryPartnerList"),
);
const OfferList = React.lazy(
  () => import("../pages/containers/Offer-CRUD/OfferList"),
);
const SubOfferView = React.lazy(
  () => import("../pages/containers/Offer-CRUD/SubOfferView"),
);
const VendingMachineList = React.lazy(
  () => import("../pages/containers/VendingMachine-CRUD/VendingMachineList"),
);

const ChangePlanogramMultipleVM = React.lazy(
  () =>
    import("../pages/containers/VendingMachine-CRUD/ChangePlanogramMultipleVM/ChangePlanogramMultipleVM"),
);
const ShippingList = React.lazy(
  () => import("../pages/containers/Shipping-CRUD/ShippingList"),
);
const FranchiseList = React.lazy(
  () => import("../pages/containers/Franchise-CRUD/FranchiseList"),
);
const SalesAnalytics = React.lazy(
  () => import("../pages/containers/Sales-Analytics/index"),
);
const OrderList = React.lazy(
  () => import("../pages/containers/Order-CRUD/OrderList"),
);
const DirectSaleList = React.lazy(
  () => import("../pages/containers/Order-CRUD/DirectSaleList"),
);
const CustomerFeedbackList = React.lazy(
  () =>
    import("../pages/containers/CustomerFeedback/CustomerFeedbackList/CustomerFeedbackList"),
);

const ThirdPartySalesList = React.lazy(
  () => import("../pages/containers/ThirdPartySales/ThirdPartySalesList"),
);

const PlatformLinkedVMList = React.lazy(
  () => import("../pages/containers/ThirdPartySales/LinkedVMList"),
);

const VMRestrictedProductList = React.lazy(
  () => import("../pages/containers/ThirdPartySales/LinkedProducts"),
);

const NegativeItemList = React.lazy(
  () => import("../pages/containers/NegativeItems-CRUD/NegativeItemsList"),
);

const AddNegativeItem = React.lazy(
  () => import("../pages/containers/NegativeItems-CRUD/AddNegativeItem"),
);

const NegativeItemView = React.lazy(
  () => import("../pages/containers/NegativeItems-CRUD/NegativeItemView"),
);

const LinkNewItem = React.lazy(
  () => import("../pages/containers/NegativeItems-CRUD/LinkItems/LinkItem"),
);

const EditLinkItem = React.lazy(
  () => import("../pages/containers/NegativeItems-CRUD/LinkItems/EditLinkItem"),
);

const LinkNewVMNegativeitem = React.lazy(
  () =>
    import("../pages/containers/NegativeItems-CRUD/LinkVendingMachines/LinkVM"),
);

const EditVMNegativeitem = React.lazy(
  () =>
    import("../pages/containers/NegativeItems-CRUD/LinkVendingMachines/EditLinkVM"),
);

// const StoreManagerList = React.lazy(() =>
//   import(
//     "../pages/containers/StoreManagerManagement/StoreManagerList/StoreManagerList"
//   )
// );
// const StoreManagerView = React.lazy(() =>
//   import(
//     "../pages/containers/StoreManagerManagement/StoreManagerView/StoreManagerView"
//   )
// );
// const StoreManagerModify = React.lazy(() =>
//   import(
//     "../pages/containers/StoreManagerManagement/StoreManagerModify/StoreManagerModify"
//   )
// );

const VmTemplateList = React.lazy(
  () => import("../pages/containers/VmTemplate/VmTemplateList/VmTemplateList"),
);
const MasterConfig = React.lazy(
  () =>
    import("../pages/containers/VendingMachine-CRUD/MasterConfig/MasterConfig"),
);
const MainSection = React.lazy(
  () =>
    import("../pages/containers/VendingMachine-CRUD/MasterConfig/components/MainSection/MainSection"),
);
const VmTemplateOverview = React.lazy(
  () =>
    import("../pages/containers/VmTemplate/VmTemplateOverview/VmTemplateOverview"),
);

const VmTemplateModify = React.lazy(
  () =>
    import("../pages/containers/VmTemplate/VmTemplateModify/VmTemplateModify"),
);

const BulkRefillList = React.lazy(
  () => import("../pages/containers/BulkRefill/BulkRefillList/BulkRefillList"),
);

const BulkRefillOverview = React.lazy(
  () =>
    import("../pages/containers/BulkRefill/BulkRefillOverview/BulkRefillOverview"),
);

const BulkRefillModify = React.lazy(
  () =>
    import("../pages/containers/BulkRefill/BulkRefillModify/BulkRefillModify"),
);

const VmSettingsList = React.lazy(
  () => import("../pages/containers/VmSettings/VmSettingsList/VmSettingsList"),
);

const VmSettingsOverview = React.lazy(
  () =>
    import("../pages/containers/VmSettings/VmSettingsOverview/VmSettingsOverview"),
);

const VmSettingsModify = React.lazy(
  () =>
    import("../pages/containers/VmSettings/VmSettingsModify/VmSettingsModify"),
);

const PlanogramTemplateList = React.lazy(
  () =>
    import("../pages/containers/PlanogramTemplate-CRUD/PlanogramTemplateList"),
);
const AddPlanogramTemplate = React.lazy(
  () =>
    import("../pages/containers/PlanogramTemplate-CRUD/AddPlanogramTemplate"),
);
const EditPlanogramTemplate = React.lazy(
  () =>
    import("../pages/containers/PlanogramTemplate-CRUD/EditPlanogramTemplate"),
);
const ClonePlanogramTemplate = React.lazy(
  () =>
    import("../pages/containers/PlanogramTemplate-CRUD/ClonePlanogramTemplate"),
);
const ViewPlanogramTemplate = React.lazy(
  () =>
    import("../pages/containers/PlanogramTemplate-CRUD/ViewPlanogramTemplate"),
);
const ReturnOrderView = React.lazy(
  () => import("../pages/containers/RefillManagement-CRUD/ReturnOrderView"),
);

// new analytics module
const Analytics = React.lazy(
  () => import("../pages/containers/Analytics/Analytics"),
);

const RequestOrderOverview = React.lazy(
  () =>
    import("../pages/containers/Warehouse-CRUD/RequestOrder/RequestOrderOverview"),
);

const TransferOrderOverview = React.lazy(
  () =>
    import("../pages/containers/Warehouse-CRUD/TransferOrder/TransferOrderOverview"),
);
const PgModuleOverview = React.lazy(
  () => import("../pages/containers/Order-CRUD/PgModule/PgModuleOverview"),
);

const ActionHistory = React.lazy(
  () => import("../pages/containers/ActionHistory/ActionHistory"),
);

const IncidentList = React.lazy(
  () => import("../pages/containers/Technician-CRUD/IncidentList"),
);

const AddIncidentType = React.lazy(
  () => import("../pages/containers/Technician-CRUD/AddIncidentType"),
);

const AddIncident = React.lazy(
  () => import("../pages/containers/Technician-CRUD/AddIncident"),
);

const JobList = React.lazy(
  () => import("../pages/containers/Technician-CRUD/JobList"),
);

const AddJob = React.lazy(
  () => import("../pages/containers/Technician-CRUD/AddJob"),
);

const JobOverview = React.lazy(
  () => import("../pages/containers/Technician-CRUD/JobOverview"),
);
const TechnicianLogs = React.lazy(
  () => import("../pages/containers/Technician-CRUD/TechnicianLogs"),
);
const MotorActionLogs = React.lazy(
  () => import("../pages/containers/Technician-CRUD/MotorActionLogs"),
);
const VmListTechnician = React.lazy(
  () =>
    import("../pages/containers/Technician-VendingMachine-CRUD/VendingMachineList"),
);
const VendingMachineViewTechnician = React.lazy(
  () =>
    import("../pages/containers/Technician-VendingMachine-CRUD/VendingMachineView"),
);

const ROUTES = [
  {
    title: "Dashboard Management",
    icon: DashboardIcon,
    activeIcon: DashboardActiveIcon,
    component: Dashboard,
    route: "/dashboard",
    sidebar: true,
    hasSubRoutes: true,
    permissions: [PERMISSIONS.PERM_VIEW_DASHBOARD],
  },
  {
    title: "Dashboard",
    // icon: DashboardIcon,
    // activeIcon: DashboardActiveIcon,
    component: Dashboard,
    route: "/dashboard",
    sidebar: false,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_DASHBOARD],
  },

  // vm analytics sub module
  {
    title: "VM Analytics",
    component: Analytics,
    route: APP_ROUTES.VM_ANALYTICS,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_DASHBOARD],
  },

  // {
  // 	title: 'Role Management',
  // 	icon: RoleMngIcon,
  // 	activeIcon: RoleMngActiveIcon,
  // 	component: RolesList,
  // 	route: '/roles',
  // 	sidebar: true,
  // 	permissions: []
  // },
  // {
  // 	title: 'Role Management',
  // 	component: RoleView,
  // 	route: '/role/:id',
  // 	sidebar: false,
  // 	permissions: []
  // },
  // {
  // 	title: 'Role Management',
  // 	component: RoleEdit,
  // 	route: '/add-role',
  // 	sidebar: false,
  // 	permissions: []
  // },
  // {
  // 	title: 'Role Management',
  // 	component: RoleEdit,
  // 	route: '/edit-role/:id',
  // 	sidebar: false,
  // 	permissions: []
  // },
  {
    title: "User Management",
    icon: UserMngIcon,
    activeIcon: UserMngActiveIcon,
    component: UsersList,
    route: "/users",
    sidebar: true,
    hasSubRoutes: true,
    permissions: [
      PERMISSIONS.PERM_VIEW_COMPANY_PARTNER,
      PERMISSIONS.PERM_VIEW_FRANCHISE_ADMIN,
      PERMISSIONS.PERM_VIEW_COMPANY_ADMIN,
      PERMISSIONS.PERM_VIEW_STORE_MANAGER,
      PERMISSIONS.PERM_VIEW_WAREHOUSE_MANAGER,
      PERMISSIONS.PERM_VIEW_OPERATOR,
      PERMISSIONS.PERM_VIEW_RETAILER_ADMIN,
    ],
  },
  {
    title: "User List",
    component: UserView,
    route: "/user/:id",
    sidebar: false,
    permissions: [
      PERMISSIONS.PERM_VIEW_COMPANY_PARTNER,
      PERMISSIONS.PERM_VIEW_FRANCHISE_ADMIN,
      PERMISSIONS.PERM_VIEW_COMPANY_ADMIN,
      PERMISSIONS.PERM_VIEW_STORE_MANAGER,
      PERMISSIONS.PERM_VIEW_WAREHOUSE_MANAGER,
      PERMISSIONS.PERM_VIEW_OPERATOR,
      PERMISSIONS.PERM_VIEW_RETAILER_ADMIN,
    ],
  },
  {
    title: "User List",
    component: AddUser,
    route: "/add-user",
    sidebar: false,
    permissions: [
      PERMISSIONS.PERM_ADD_COMPANY_PARTNER,
      PERMISSIONS.PERM_ADD_FRANCHISE_ADMIN,
      PERMISSIONS.PERM_ADD_COMPANY_ADMIN,
    ],
  },
  {
    title: "User List",
    component: AddUser,
    route: "/edit-user/:id",
    sidebar: false,
    permissions: [
      PERMISSIONS.PERM_UPDATE_COMPANY_PARTNER,
      PERMISSIONS.PERM_UPDATE_FRANCHISE_ADMIN,
      PERMISSIONS.PERM_UPDATE_COMPANY_ADMIN,
    ],
  },
  {
    title: "User List",
    component: AddWarehouseManager,
    route: APP_ROUTES.CREATE_WAREHOUSE_MANAGER,
    sidebar: false,
    permissions: [
      PERMISSIONS.PERM_UPDATE_COMPANY_PARTNER,
      PERMISSIONS.PERM_UPDATE_FRANCHISE_ADMIN,
      PERMISSIONS.PERM_UPDATE_COMPANY_ADMIN,
    ],
  },
  {
    title: "User List",
    component: AddWarehouseManager,
    route: APP_ROUTES.EDIT_WAREHOUSE_MANAGER,
    sidebar: false,
    permissions: [
      PERMISSIONS.PERM_UPDATE_COMPANY_PARTNER,
      PERMISSIONS.PERM_UPDATE_FRANCHISE_ADMIN,
      PERMISSIONS.PERM_UPDATE_COMPANY_ADMIN,
    ],
  },
  {
    title: "User List",
    component: ViewWarehouseManager,
    route: APP_ROUTES.VIEW_WAREHOUSE_MANAGER,
    sidebar: false,
    permissions: [
      PERMISSIONS.PERM_UPDATE_COMPANY_PARTNER,
      PERMISSIONS.PERM_UPDATE_FRANCHISE_ADMIN,
      PERMISSIONS.PERM_UPDATE_COMPANY_ADMIN,
    ],
  },
  {
    title: "User Management",
    component: LinkWarehouseforWM,
    route: APP_ROUTES.LINKED_NEW_WAREHOUSE_FOR_WM,
    sidebar: false,
    permissions: [],
  },
  {
    title: "User Management",
    component: EditLinkWarehouseforWM,
    route: APP_ROUTES.EDIT_LINKED_WAREHOUSE_FOR_WM,
    sidebar: false,
    permissions: [],
  },
  {
    title: "User List",
    component: UsersList,
    route: "/users",
    permissions: [
      PERMISSIONS.PERM_VIEW_COMPANY_PARTNER,
      PERMISSIONS.PERM_VIEW_FRANCHISE_ADMIN,
      PERMISSIONS.PERM_VIEW_COMPANY_ADMIN,
      PERMISSIONS.PERM_VIEW_STORE_MANAGER,
      PERMISSIONS.PERM_VIEW_WAREHOUSE_MANAGER,
      PERMISSIONS.PERM_VIEW_OPERATOR,
      PERMISSIONS.PERM_VIEW_RETAILER_ADMIN,
    ],
    subSidebar: true,
  },

  {
    title: "Report Catalog",
    icon: reports,
    activeIcon: reports,
    component: ReportsList,
    route: "/reports-list",
    sidebar: true,
    hasSubRoutes: true,
    permissions: [PERMISSIONS.PERM_VIEW_REPORT_MODULE],
  },

  {
    title: "Report Catalog",
    component: ReportsList,
    route: "/reports-list",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_REPORT_MODULE],
  },

  {
    title: "Generate Report",
    component: GenerateReport,
    route: "/generate-report",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_REPORT_MODULE],
  },
  {
    title: "Recurring Reports",
    component: RecurringReports,
    route: "/recurring-reports",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_REPORT_MODULE],
  },

  {
    title: "Vending Machines",
    component: SystemAuditorVendingMachineList,
    route: "/system-auditor-vending-machine",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_REPORT_MODULE],
  },

  {
    title: "Refill Trigger",
    component: RefillTrigger,
    route: "/refill-trigger",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_REPORT_MODULE],
  },

  {
    title: "Incident Trigger",
    component: IncidentTrigger,
    route: "/incident-trigger",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_REPORT_MODULE],
  },

  {
    title: "Planogram Adherence",
    component: PlanogramAdherence,
    route: "/planogram-adherence",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_REPORT_MODULE],
  },

  {
    title: "Report Catalog",
    component: ReportsList,
    route: "/reports-list/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_REPORT_MODULE],
  },

  {
    title: "System Auditor",
    icon: setup,
    activeIcon: setup,
    component: MasterDataSetup,
    route: APP_ROUTES.MASTER_DATA_SETUP,
    sidebar: true,
    hasSubRoutes: true,
    permissions: [PERMISSIONS.PERM_VIEW_SYSTEM_AUDITOR],
  },

  {
    title: "Master Data Setup",
    component: MasterDataSetup,
    route: APP_ROUTES.MASTER_DATA_SETUP,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_SYSTEM_AUDITOR],
  },

  {
    title: "Product Catalog",
    icon: ProductCatalogIcon,
    activeIcon: ProductCatalogActiveIcon,
    component: ProductList,
    route: "/products",
    sidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATALOG],
    hasSubRoutes: true,
  },
  {
    title: "Product Catalog",
    // component: ProductView,
    component: ProductList,
    route: "/product/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATALOG],
  },
  {
    title: "Product Catalog",
    component: AddProduct,
    route: "/add-product",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_PRODUCT_CATALOG],
  },
  {
    title: "Product Catalog",
    component: AddProduct,
    route: "/edit-product/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_PRODUCT_CATALOG],
  },
  {
    title: "Product Catalog",
    component: ProductFeedback,
    route: "/product-feedback/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATALOG],
  },
  {
    title: "Product Catalog",
    component: ProductsRequested,
    route: "/products-requested",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATALOG],
  },
  {
    title: "Product Catalog",
    component: AddRequestProduct,
    route: APP_ROUTES.ADD_REQUEST_PRODUCT,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATALOG],
  },
  {
    title: "Product Catalog",
    component: ViewRequestProduct,
    route: APP_ROUTES.VIEW_REQUEST_PRODUCT,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATALOG],
  },

  {
    title: "Product List",
    component: ProductList,
    route: "/products",
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATALOG],
    subSidebar: true,
  },
  {
    title: "Product Category",
    icon: ArrowSide,
    activeIcon: ArrowSideActive,
    component: ProductCategoryList,
    route: "/product-categories",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATEGORY],
  },
  {
    title: "Product Category",
    // component: ProductCategoryView,
    component: ProductCategoryList,
    route: "/product-category/:id",
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATEGORY],
  },
  {
    title: "Product Brand",
    icon: ArrowSide,
    activeIcon: ArrowSideActive,
    component: ProductBrandList,
    route: "/product-brands",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_BRAND],
  },
  {
    title: "Product Brand",
    // component: ProductBrandView,
    component: ProductBrandList,
    route: "/product-brand/:id",
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_BRAND],
  },
  {
    title: "Product Unit",
    icon: ArrowSide,
    activeIcon: ArrowSideActive,
    component: ProductUnitList,
    route: "/product-units",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_UNIT],
  },
  {
    title: "Product Unit",
    // component: ProductUnitView,
    component: ProductUnitList,
    route: "/product-unit/:id",
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_UNIT],
  },
  {
    title: "Product Packaging",
    icon: ArrowSide,
    activeIcon: ArrowSideActive,
    component: ProductPackagingList,
    route: "/product-packagings",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_PACKAGING],
  },
  {
    title: "Product Packaging",
    // component: ProductPackagingView,
    component: ProductPackagingList,
    route: "/product-packaging/:id",
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_PACKAGING],
  },
  {
    title: "Sync Product List",
    icon: ArrowSide,
    activeIcon: ArrowSideActive,
    component: SyncProductList,
    route: APP_ROUTES.SYNC_PRODUCT_LIST,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATALOG],
  },
  {
    title: "New Product List",
    icon: ArrowSide,
    activeIcon: ArrowSideActive,
    component: NewProductList,
    route: APP_ROUTES.NEW_PRODUCT_LIST,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATALOG],
  },
  {
    title: "Sync Product List",
    component: SyncBrandCatalogues,
    route: "/sync-products/:id",
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATALOG],
  },
  {
    title: "Sync Product List",
    component: SyncCatalogueProducts,
    route: "/sync-products/:brandId/catalogue/:catalogueId",
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATALOG],
  },

  {
    title: "Supplier Management",
    icon: SupplierManagementIcon,
    activeIcon: SupplierManagementActiveIcon,
    component: SupplierList,
    route: APP_ROUTES.SUPPLIER_LIST,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_SUPPLIER],
  },
  {
    title: "Supplier Management",
    component: SupplierModify,
    route: APP_ROUTES.SUPPLIER_ADD,
    // sidebar: false,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_SUPPLIER],
  },
  {
    title: "Warehouse Management",
    component: SupplierReturnOverview,
    // route: APP_ROUTES.SUPPLIER_RETURN_OVERVIEW,
    route: "/warehouse/:warehouseId/supplier-return-overview/:id",
    // sidebar: false,
    subSidebar: false,
    permissions: [],
  },
  {
    title: "Supplier Management",
    component: SupplierModify,
    route: APP_ROUTES.SUPPLIER_EDIT,
    // sidebar: false,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_SUPPLIER],
  },
  {
    title: "Supplier Management",
    component: SupplierView,
    route: APP_ROUTES.SUPPLIER_VIEW,
    // sidebar: false,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_SUPPLIER],
  },
  {
    title: "Procurement Management",
    icon: PurchaseOrderManagementIcon,
    activeIcon: PurchaseOrderManagementActiveIcon,
    component: PurchaseOrderList,
    route: APP_ROUTES.PURCHASE_ORDER_LIST,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_PROCUREMENT_MGMT],
  },
  {
    title: "Warehouse Order",
    icon: PurchaseOrderManagementIcon,
    activeIcon: PurchaseOrderManagementActiveIcon,
    component: WarehouseOrderList,
    route: APP_ROUTES.WAREHOUSE_ORDER_LIST,
    subSidebar: true,
    permissions: [],
  },
  {
    title: "Warehouse Management",
    component: PackageTransferView,
    route: APP_ROUTES.VIEW_PACKAGE_TRANSFER,
    subSidebar: false,
    permissions: [],
  },
  {
    title: "Warehouse Management",
    component: KitTransferView,
    route: APP_ROUTES.VIEW_KIT_TRANSFER,
    subSidebar: false,
    permissions: [],
  },
  {
    title: "Warehouse Management",
    component: SaleOrderView,
    route: APP_ROUTES.VIEW_SALE_ORDER,
    subSidebar: false,
    permissions: [],
  },
  {
    title: "Warehouse Stock",
    component: WarehouseStock,
    route: APP_ROUTES.WAREHOUSE_STOCK,
    subSidebar: false,
    permissions: [],
  },
  {
    title: "Procurement Management",
    component: PurchaseOrderModify,
    route: APP_ROUTES.PURCHASE_ORDER_ADD,
    // sidebar: false,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_PROCUREMENT_MGMT],
  },
  {
    title: "Procurement Management",
    component: AddPurchaseReturn,
    route: APP_ROUTES.PURCHASE_RETURN_ADD,
    // sidebar: false,
    subSidebar: false,
    permissions: [],
  },
  {
    title: "Procurement Management",
    component: AddPurchaseReturn,
    route: APP_ROUTES.PURCHASE_RETURN_EDIT,
    // sidebar: false,
    subSidebar: false,
    permissions: [],
  },
  {
    title: "Procurement Management",
    component: AddPurchaseReturn,
    route: APP_ROUTES.PURCHASE_ORDER_RETURN,
    // sidebar: false,
    subSidebar: false,
    permissions: [],
  },

  {
    title: "Procurement Management",
    component: PurchaseOrderModify,
    route: APP_ROUTES.PURCHASE_ORDER_EDIT,
    // sidebar: false,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_PROCUREMENT_MGMT],
  },
  {
    title: "Procurement Management",
    component: PurchaseOrderModify,
    route: APP_ROUTES.SAME_PURCHASE_ORDER,
    // sidebar: false,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_PROCUREMENT_MGMT],
  },

  {
    title: "Procurement Management",
    component: PurchaseOrderView,
    route: APP_ROUTES.PURCHASE_ORDER_VIEW,
    // sidebar: false,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_PROCUREMENT_MGMT],
  },

  {
    title: "Procurement Management",
    component: PurchaseReturnView,
    route: APP_ROUTES.PURCHASE_RETURN_VIEW,
    // sidebar: false,
    subSidebar: false,
    permissions: [],
  },
  {
    title: "Procurement Management",
    component: PurchaseOrderManageView,
    route: APP_ROUTES.PURCHASE_ORDER_MANAGE,
    // sidebar: false,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_PROCUREMENT_MGMT],
  },

  {
    title: "Cash Order",
    component: CashCollectionView,
    route: APP_ROUTES.VIEW_CASH_COLLECTION,
    // sidebar: false,
    subSidebar: false,
    permissions: [],
  },

  {
    title: "Warehouse Management",
    icon: WarehouseMngIcon,
    activeIcon: WarehouseMngActiveIcon,
    component: WarehouseList,
    route: "/warehouses",
    sidebar: true,
    hasSubRoutes: true,
    permissions: [PERMISSIONS.PERM_VIEW_WAREHOUSE_MODULE],
  },
  {
    title: "Warehouse Management",
    component: AddWarehouse,
    route: "/add-warehouse",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_WAREHOUSE],
  },
  {
    title: "Warehouse Management",
    component: WarehouseView,
    route: APP_ROUTES.VIEW_WAREHOUSE,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_WAREHOUSE],
  },
  {
    title: "Warehouse List",
    component: WarehouseList,
    route: "/warehouses",
    permissions: [PERMISSIONS.PERM_VIEW_WAREHOUSE],
    subSidebar: true,
  },
  {
    title: "Warehouse Management",
    component: WarehouseStoreReturnOrdersView,
    route:
      "/warehouse/:id/warehouseStoreReturnOrders/:warehouseStoreReturnOrdersId",
    sidebar: false,
    permissions: [],
  },
  {
    title: "Warehouse Management",
    component: WarehouseVMReturnOrdersView,
    route: "/warehouse/:id/warehouseVMReturnOrders/:warehouseVMReturnOrdersId",
    sidebar: false,
    permissions: [],
  },
  {
    title: "Warehouse Management",
    component: AddWarehouse,
    route: "/edit-warehouse/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_WAREHOUSE],
  },
  {
    title: "Warehouse Management",
    component: TallyInventoryModify,
    route: APP_ROUTES.TALLY_INVENTORY_ADD,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Warehouse Management",
    component: LinkNewRefillPartner,
    route: APP_ROUTES.LINKED_NEW_REFILL_PARTNER,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Warehouse Management",
    component: EditLinkRefillPartner,
    route: APP_ROUTES.EDIT_LINKED_REFILL_PARTNER,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Warehouse Management",
    component: LinkNewWarehouseManager,
    route: APP_ROUTES.LINKED_NEW_WAREHOUSE_MANAGER,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Warehouse Management",
    component: EditLinkWarehouseManager,
    route: APP_ROUTES.EDIT_LINKED_WAREHOUSE_MANAGER,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Inventory Management",
    // icon: InventoryMngIcon,
    icon: InventoryIcon,
    activeIcon: InventoryMngActiveIcon,
    component: InventoryList,
    route: "/inventory",
    sidebar: true,
    hasSubRoutes: true,
    permissions: [PERMISSIONS.PERM_VIEW_INVENTORY],
  },
  {
    title: "Inventory Management",
    component: InventoryList,
    route: "/warehouse-inventory/:warehouseId",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_INVENTORY],
  },
  {
    title: "Inventory Management",
    // icon: InventoryMngIcon,
    icon: InventoryIcon,
    activeIcon: InventoryMngActiveIcon,
    component: InventoryList,
    route: "/inventory",
    permissions: [PERMISSIONS.PERM_VIEW_INVENTORY],
    subSidebar: true,
  },

  // {
  //   title: "Zone Management",
  //   // icon: ZoneMngIcon,
  //   icon: ZoneIcon,
  //   activeIcon: ZoneMngActiveIcon,
  //   component: ZoneList,
  //   route: "/zones",
  //   sidebar: true,
  //   hasSubRoutes: true,
  //   permissions: [PERMISSIONS.PERM_VIEW_ZONE],
  // },
  {
    title: "Zone Management",
    component: AddZone,
    route: "/add-zone",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_ZONE],
  },
  {
    title: "Zone Management",
    component: AddZone,
    route: "/edit-zone/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_ZONE],
  },
  {
    title: "Zone Management",
    component: ZoneView,
    route: APP_ROUTES.VIEW_ZONE,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_ZONE],
  },
  {
    title: "Zone Management",
    // icon: ZoneMngIcon,
    icon: ZoneIcon,
    activeIcon: ZoneMngActiveIcon,
    component: ZoneList,
    route: "/zones",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_ZONE],
  },
  // {
  //   title: "Delivery Partner",
  //   // icon: PartnerMngIcon,
  //   icon: DeliveryPartnerIcon,
  //   activeIcon: PartnerMngActiveIcon,
  //   component: DeliveryPartnerList,
  //   route: "/delivery-partners",
  //   sidebar: true,
  //   hasSubRoutes: true,
  //   permissions: [PERMISSIONS.PERM_VIEW_DELIVERY_PARTNER],
  // },
  {
    title: "Delivery Partner",
    component: AddDeliveryPartner,
    route: "/add-delivery-partner",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_DELIVERY_PARTNER],
  },
  {
    title: "Delivery Partner",
    component: AddDeliveryPartner,
    route: "/edit-delivery-partner/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_DELIVERY_PARTNER],
  },
  {
    title: "Delivery Partner",
    component: DeliveryPartnerView,
    route: "/delivery-partner/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_DELIVERY_PARTNER],
  },
  {
    title: "Delivery Partner",
    component: DeliveryPartnerList,
    route: "/delivery-partners",
    permissions: [PERMISSIONS.PERM_VIEW_DELIVERY_PARTNER],
    subSidebar: true,
  },
  {
    title: "Entity",
    icon: FranchiseIcon,
    activeIcon: FranchiseMngActiveIcon,
    component: FranchiseList,
    route: "/franchises",
    sidebar: true,
    hasSubRoutes: true,
    permissions: [PERMISSIONS.PERM_VIEW_FRANCHISE_MODULE],
  },

  {
    title: "Franchise Management",
    // icon: FranchiseMngIcon,
    // icon: FranchiseIcon,
    // activeIcon: FranchiseMngActiveIcon,
    component: FranchiseList,
    route: "/franchises",
    // sidebar: true,
    // hasSubRoutes: true,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_FRANCHISE],
  },
  {
    title: "Franchise Management",
    component: AddFranchise,
    route: "/add-franchise",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_FRANCHISE],
  },
  {
    title: "Franchise Management",
    component: AddFranchise,
    route: "/edit-franchise/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_FRANCHISE],
  },
  {
    title: "Franchise Management",
    component: FranchiseView,
    route: "/franchise/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_FRANCHISE],
  },
  // {
  //   title: "Franchise Management",
  //   component: FranchiseList,
  //   route: "/franchises",
  //   subSidebar: true,
  //   permissions: [PERMISSIONS.PERM_VIEW_FRANCHISE],
  // },

  // {
  //   title: "Store Management",
  //   // icon: StoreMngIcon,
  //   icon: StoreIcon,
  //   activeIcon: StoreMngActiveIcon,
  //   component: StoreList,
  //   route: "/stores",
  //   sidebar: true,
  //   permissions: [PERMISSIONS.PERM_VIEW_STORE],
  //   // hasSubRoutes: true,
  //   hasSubRoutes: true,
  // },
  {
    title: "Store Management",
    component: StoreInventoryList,
    route: "/store-inventory/:id",
    sidebar: false,
    permissions: [],
  },
  {
    title: "Store Management",
    component: AddShipping,
    route: APP_ROUTES.GENERATE_SHIPPING_ORDER_REQUEST,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Store Management",
    component: StoreList,
    route: "/stores",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_STORE],
  },
  // {
  //   title: "Store Manager",
  //   subSidebar: true,
  //   icon: ArrowSide,
  //   activeIcon: ArrowSideActive,
  //   component: StoreManagerList,
  //   route: APP_ROUTES.STORE_MANAGER_LIST,
  //   sidebar: false,
  //   permissions: [PERMISSIONS.PERM_VIEW_STORE_MANAGER],
  // },
  // {
  //   title: "Store Manager",
  //   component: StoreManagerModify,
  //   route: APP_ROUTES.STORE_MANAGER_ADD,
  //   sidebar: false,
  //   permissions: [PERMISSIONS.PERM_ADD_STORE_MANAGER],
  // },
  // {
  //   title: "Store Manager",
  //   component: StoreManagerModify,
  //   route: APP_ROUTES.STORE_MANAGER_EDIT,
  //   sidebar: false,
  //   permissions: [PERMISSIONS.PERM_UPDATE_STORE_MANAGER],
  // },
  // {
  //   title: "Store Manager",
  //   component: StoreManagerView,
  //   route: APP_ROUTES.STORE_MANAGER_VIEW,
  //   sidebar: false,
  //   permissions: [PERMISSIONS.PERM_VIEW_STORE_MANAGER],
  // },
  {
    title: "Franchise Management",
    component: StoreList,
    route: "/franchise/:franchiseId/stores",
    permissions: [PERMISSIONS.PERM_VIEW_STORE],
  },
  {
    title: "Franchise Management",
    component: AddStore,
    route: "/franchise/:franchiseId/add-store",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_STORE],
  },
  {
    title: "Franchise Management",
    component: AddStore,
    route: "/franchise/:franchiseId/edit-store/:storeId",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_STORE],
  },
  {
    title: "Franchise Management",
    component: StoreView,
    route: "/franchise/:franchiseId/store/:storeId",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_STORE],
  },

  {
    title: "Franchise Management",
    component: AddStoreReturn,
    route: APP_ROUTES.CREATE_STORE_RETURN,
    sidebar: false,
    permissions: [],
  },
  // Store vm retunrs overview page
  {
    title: "Franchise Management",
    component: StoreVmsReturnsOverView,
    route:
      "/franchise/:franchiseId/store/:storeId/storeVmReturnOrderId/:returnOrderId",
    sidebar: false,
    permissions: [],
  },

  // Store store return overview page
  {
    title: "Franchise Management",
    component: StoreStoreReturnsOverView,
    route:
      "/franchise/:franchiseId/store/:storeId/storeStoreReturnOrderId/:storeStoreReturnOrderId",
    sidebar: false,
    permissions: [],
  },
  {
    title: "Shipping Management",
    // icon: ShippingIcon,
    icon: ShippingManagementIcon,
    activeIcon: ShippingActiveIcon,
    component: ShippingList,
    route: "/shippings",
    // sidebar: true,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_SHIPPING],
  },
  {
    title: "Shipping Management",
    component: ShippingView,
    route: APP_ROUTES.VIEW_SHIPPING_ORDER,
    // sidebar: false,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_SHIPPING],
  },
  {
    title: "Shipping Management",
    component: AddShipping,
    route: APP_ROUTES.CREATE_SHIPPING_ORDER,
    // sidebar: false,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_SHIPPING],
  },
  {
    title: "Shipping Management",
    component: ShippingManageView,
    route: APP_ROUTES.MANAGE_SHIPPING_ORDER,
    subSidebar: false,
    // sidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_SHIPPING],
  },
  {
    title: "Delivery Person",
    icon: DeliveryPersonIcon,
    activeIcon: DeliveryPersonActiveIcon,
    component: DeliveryPersonList,
    route: "/delivery-persons",
    sidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_DELIVERY_PERSON],
  },
  {
    title: "Delivery Person",
    component: AddDeliveryPerson,
    route: "/add-delivery-person",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_DELIVERY_PERSON],
  },
  {
    title: "Delivery Person",
    component: AddDeliveryPerson,
    route: "/edit-delivery-person/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_DELIVERY_PERSON],
  },
  {
    title: "Delivery Person",
    component: DeliveryPersonView,
    route: "/delivery-person/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_DELIVERY_PERSON],
  },
  //REFILL PARTNER ROUTES ADDED HERE
  // {
  //   title: "Refill Partner",
  //   // icon: DeliveryPersonIcon,
  //   icon: RefillPartnerIcon,
  //   activeIcon: DeliveryPersonActiveIcon,
  //   component: RefillPartnerList,
  //   route: APP_ROUTES.REFILL_PARTNER_LIST,
  //   sidebar: true,
  //   hasSubRoutes: true,
  //   permissions: [PERMISSIONS.PERM_VIEW_REFILL_PARTNER],
  // },
  {
    title: "Refill Partner",
    component: AddRefillPartner,
    route: APP_ROUTES.REFILL_PARTNER_ADD,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_REFILL_PARTNER],
  },
  {
    title: "Refill Partner",
    component: AddRefillPartner,
    route: APP_ROUTES.REFILL_PARTNER_EDIT,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_REFILL_PARTNER],
  },
  {
    title: "Refill Partner",
    component: RefillPartnerView,
    route: APP_ROUTES.REFILL_PARTNER_VIEW,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_REFILL_PARTNER],
  },
  {
    title: "Refill Partner",
    component: RefillPartnerList,
    route: APP_ROUTES.REFILL_PARTNER_LIST,
    permissions: [PERMISSIONS.PERM_VIEW_REFILL_PARTNER],
    subSidebar: true,
  },
  {
    title: "Refill Partner",
    component: LinkNewVM,
    route: APP_ROUTES.LINKED_NEW_VM,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Refill Partner",
    component: EditLinkVM,
    route: APP_ROUTES.EDIT_LINKED_VM,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Refill Partner",
    component: LinkNewWarehouse,
    route: APP_ROUTES.LINKED_NEW_WAREHOUSE,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Refill Partner",
    component: EditLinkWarehouse,
    route: APP_ROUTES.EDIT_LINKED_WAREHOUSE,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Refill Partner",
    component: LinkNewVehicle,
    route: APP_ROUTES.LINKED_NEW_VEHICLE,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Refill Partner",
    component: EditLinkVehicle,
    route: APP_ROUTES.EDIT_LINKED_VEHICLE,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Refill Partner",
    component: LinkRefillerPermission,
    route: APP_ROUTES.LINK_REFILL_PERMISSION,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Refill Partner",
    component: EditLinkRefillerPermission,
    route: APP_ROUTES.EDIT_LINK_REFILL_PERMISSION,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Refill Partner",
    component: LinkRefillerNotifications,
    route: APP_ROUTES.LINK_REFILL_NOTIFICATIONS,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Refill Partner",
    component: LinkRefillerNotifications,
    route: APP_ROUTES.EDIT_LINK_REFILL_NOTIFICATIONS,
    sidebar: false,
    permissions: [],
  },

  // Retailers list Routes Here
  // {
  //   title: "Retailers",
  //   // icon: DeliveryPersonIcon,
  //   icon: RetailerIcon,
  //   activeIcon: DeliveryPersonActiveIcon,
  //   component: RetailersList,
  //   route: APP_ROUTES.RETAILERS,
  //   // sidebar: true,
  //   // hasSubRoutes: true,
  //   permissions: [PERMISSIONS.PERM_VIEW_RETAILER_ENTITY],
  // },

  {
    title: "Retailers",
    component: RetailersList,
    route: APP_ROUTES.RETAILERS,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_RETAILER_ENTITY],
  },

  // REFILL PLAN ROUTES ADDED HERE
  {
    title: "Refill Plan",
    icon: RefillPlanIcon,
    activeIcon: RefillPlanIcon,
    component: RefillManagementList,
    route: APP_ROUTES.LIST_REFILLS,
    hasSubRoutes: true,
    sidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_REFILL],
  },
  {
    title: "Refill Plan",
    component: RefillManagementList,
    route: APP_ROUTES.LIST_REFILLS,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_REFILL],
  },
  {
    title: "Refill Plan",
    component: TallyOrderOverview,
    route: APP_ROUTES.VIEW_TALLY_ORDER_OVERVIEW,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Refill Plan",
    component: CashOrderOverview,
    route: APP_ROUTES.VIEW_CASH_ORDER_OVERVIEW,
    sidebar: false,
    permissions: [],
  },

  {
    title: "Refill Plan",
    component: TopUpOverview,
    route: APP_ROUTES.VIEW_TOPUP_OVERVIEW,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Warehouse Management",
    component: KitTransferModify,
    route: APP_ROUTES.CREATE_KIT_TRANSFER,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_REFILL],
  },
  {
    title: "Warehouse Management",
    component: PackageTransferModify,
    route: APP_ROUTES.CREATE_PACKAGE_TRANSFER,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_REFILL],
  },
  {
    title: "Master Configuration",
    component: MainSection,
    route: APP_ROUTES.VENDING_MACHINE_MASTER_CONFIG,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Vending Machine",
    // icon: VendingMachineMngIcon,
    icon: VendingMachineIcon,
    activeIcon: VendingMachineMngActiveIcon,
    component: VendingMachineList,
    route: "/vm",
    hasSubRoutes: true,
    sidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_VM_MODULE],
  },
  {
    title: "VM List",
    component: VendingMachineList,
    route: "/vm",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_VENDING_MACHINE],
  },

  {
    title: "Vending Machine",
    route: APP_ROUTES.CHANGE_PLANOGRAM_FOR_MULTIPLE_VMs,
    component: ChangePlanogramMultipleVM,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Vending Machine",
    component: VendingMachineView,
    route: "/vm/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_VENDING_MACHINE],
  },
  {
    title: "Vending Machine",
    component: DeletedVendingMachineView,
    route: "/deletedVm/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_VENDING_MACHINE],
  },
  {
    title: "Vending Machine",
    component: CreateVendingMachine,
    route: APP_ROUTES.CREATE_VENDING_MACHINE,
    sidebar: false,
    permissions: [],

    // permissions: [PERMISSIONS.PERM_UPDATE_VENDING_MACHINE],
  },
  {
    title: "Vending Machine",
    component: CreateVendingMachine,
    route: APP_ROUTES.EDIT_VENDING_MACHINE,
    sidebar: false,
    permissions: [],
    // permissions: [PERMISSIONS.PERM_UPDATE_VENDING_MACHINE],
  },
  {
    title: "Vending Machine",
    component: RefillManagementList,
    route: APP_ROUTES.LIST_REFILLS,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_REFILL],
  },
  {
    title: "Vending Machine",
    component: RefillManagementView,
    route: APP_ROUTES.VIEW_REFILL_PLAN,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_REFILL],
  },
  {
    title: "Vending Machine",
    component: AddRefillManagement,
    route: APP_ROUTES.ADD_REFILL_PLAN,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_REFILL],
  },
  {
    title: "Vending Machine",
    component: AddRefillManagement,
    route: APP_ROUTES.EDIT_REFILL_PLAN,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_REFILL],
  },
  {
    title: "Vending Machine",
    component: ReturnOrderView,
    route: APP_ROUTES.RETURN_ORDER_VIEW,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Vending Machine",
    component: VendingMachineSnapshot,
    route: "/vm-snapshot/:vmId",
    sidebar: false,
    permissions: [],
  },
  {
    title: "Vending Machine",
    component: VendingMachineFeedback,
    route: "/vm-feedback/:id",
    sidebar: false,
    permissions: [],
  },
  {
    title: "VM Templates",
    component: VmTemplateList,
    route: APP_ROUTES.VM_TEMPLATE_LIST,
    permissions: [PERMISSIONS.PERM_VIEW_VM_TEMPLATE],
    subSidebar: true,
    icon: ArrowSide,
    activeIcon: ArrowSideActive,
  },

  {
    title: "VM Template List",
    component: VmTemplateList,
    route: APP_ROUTES.TECH_VM_TEMPLATE_LIST,
    permissions: [PERMISSIONS.PERM_VIEW_VM_TEMPLATE],
    subSidebar: true,
    // icon: ArrowSide,
    // activeIcon: ArrowSideActive,
  },
  {
    title: "VM Template List",
    component: VmTemplateOverview,
    route: APP_ROUTES.TECH_VM_TEMPLATE_VIEW,
    permissions: [PERMISSIONS.PERM_VIEW_VM_TEMPLATE],
  },

  {
    title: "VM Template List",
    component: VmTemplateModify,
    route: APP_ROUTES.TECH_VM_TEMPLATE_ADD,
    permissions: [PERMISSIONS.PERM_ADD_VM_TEMPLATE],
  },

  {
    title: "VM Template List",
    component: VmTemplateModify,
    route: APP_ROUTES.TECH_VM_TEMPLATE_EDIT,
    permissions: [PERMISSIONS.PERM_UPDATE_VM_TEMPLATE],
  },
  {
    title: "VM Template List",
    component: VmTemplateModify,
    route: APP_ROUTES.TECH_VM_TEMPLATE_CLONE,
    permissions: [PERMISSIONS.PERM_VIEW_VM_TEMPLATE],
  },

  {
    title: "VM Templates",
    component: VmTemplateOverview,
    route: APP_ROUTES.VM_TEMPLATE_VIEW,
    permissions: [PERMISSIONS.PERM_VIEW_VM_TEMPLATE],
  },
  {
    title: "VM Templates",
    component: VmTemplateModify,
    route: APP_ROUTES.VM_TEMPLATE_ADD,
    permissions: [PERMISSIONS.PERM_ADD_VM_TEMPLATE],
  },
  {
    title: "VM Templates",
    component: VmTemplateModify,
    route: APP_ROUTES.VM_TEMPLATE_EDIT,
    permissions: [PERMISSIONS.PERM_UPDATE_VM_TEMPLATE],
  },
  {
    title: "VM Templates",
    component: VmTemplateModify,
    route: APP_ROUTES.VM_TEMPLATE_CLONE,
    permissions: [PERMISSIONS.PERM_ADD_VM_TEMPLATE],
  },
  {
    title: "Planogram Template",
    component: PlanogramTemplateList,
    route: APP_ROUTES.PLANOGRAM_TEMPLATE_LIST,
    subSidebar: true,
    permissions: [],
    icon: ArrowSide,
    activeIcon: ArrowSideActive,
  },
  {
    title: "Planogram Template",
    component: AddPlanogramTemplate,
    route: APP_ROUTES.PLANOGRAM_TEMPLATE_ADD,

    permissions: [],
  },
  {
    title: "Planogram Template",
    component: EditPlanogramTemplate,
    route: APP_ROUTES.PLANOGRAM_TEMPLATE_EDIT,

    permissions: [],
  },
  {
    title: "Planogram Template",
    component: ClonePlanogramTemplate,
    route: APP_ROUTES.PLANOGRAM_TEMPLATE_CLONE,
    permissions: [],
  },
  {
    title: "Planogram Template",
    component: ViewPlanogramTemplate,
    route: APP_ROUTES.PLANOGRAM_TEMPLATE_VIEW,

    permissions: [],
  },
  {
    title: "VM Board Setting Template",
    component: VmSettingsList,
    route: APP_ROUTES.VM_SETTINGS_LIST,
    permissions: [PERMISSIONS.PERM_VIEW_SETTINGS_TEMPLATE],
    subSidebar: true,
    icon: ArrowSide,
    activeIcon: ArrowSideActive,
  },
  {
    title: "VM Board Setting Template",
    component: VmSettingsOverview,
    route: APP_ROUTES.VM_SETTINGS_VIEW,
    permissions: [PERMISSIONS.PERM_VIEW_SETTINGS_TEMPLATE],
  },
  {
    title: "VM Board Setting Template",
    component: VmSettingsModify,
    route: APP_ROUTES.VM_SETTINGS_ADD,
    permissions: [
      PERMISSIONS.PERM_ADD_SETTINGS_TEMPLATE,
      PERMISSIONS.PERM_VIEW_MASTERCONFIG,
    ],
  },
  {
    title: "VM Board Setting Template",
    component: VmSettingsModify,
    route: APP_ROUTES.VM_SETTINGS_EDIT,
    permissions: [
      PERMISSIONS.PERM_UPDATE_SETTINGS_TEMPLATE,
      PERMISSIONS.PERM_VIEW_MASTERCONFIG,
    ],
  },
  {
    title: "VM Board Setting Template",
    component: VmSettingsModify,
    route: APP_ROUTES.VM_SETTINGS_CLONE,
    permissions: [
      PERMISSIONS.PERM_ADD_SETTINGS_TEMPLATE,
      PERMISSIONS.PERM_VIEW_MASTERCONFIG,
    ],
  },
  {
    title: "Bulk Refill",
    component: BulkRefillList,
    route: APP_ROUTES.BULK_REFILL_LIST,
    permissions: [PERMISSIONS.PERM_VIEW_REFILL],
    subSidebar: true,
    icon: ArrowSide,
    activeIcon: ArrowSideActive,
  },
  {
    title: "Bulk Refill",
    component: BulkRefillOverview,
    route: APP_ROUTES.BULK_REFILL_VIEW,
    permissions: [PERMISSIONS.PERM_VIEW_REFILL],
  },
  {
    title: "Bulk Refill",
    component: BulkRefillModify,
    route: APP_ROUTES.BULK_REFILL_ADD,
    permissions: [PERMISSIONS.PERM_ADD_REFILL],
  },
  {
    title: "Bulk Refill",
    component: BulkRefillModify,
    route: APP_ROUTES.BULK_REFILL_EDIT,
    permissions: [PERMISSIONS.PERM_UPDATE_REFILL],
  },

  {
    title: "Transactions",
    icon: TransactionManagementIcon,
    activeIcon: OrderManagementActiveIcon,
    component: OrderList,
    route: "/orders",
    sidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_PURCHASE_ORDER],
    hasSubRoutes: true,
  },
  {
    title: "Transaction History",
    component: OrderList,
    route: "/orders",
    sidebar: false,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_PURCHASE_ORDER],
  },
  {
    title: "Transaction History",
    component: OrderList,
    route: "/order/:id",
    sidebar: false,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_PURCHASE_ORDER],
    // hasSubRoutes: true,
  },
  {
    title: "Direct Sales",
    component: DirectSaleList,
    route: "/direct-sale",
    subSidebar: true,
    permissions: [],
    // hasSubRoutes: true,
  },
  {
    title: "Customer Feedback",
    component: CustomerFeedbackList,
    route: APP_ROUTES.CUSTOMER_FEEDBACK_LIST,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_PURCHASE_ORDER],
  },
  {
    title: "Requested Products",
    component: ProductsRequested,
    route: APP_ROUTES.REQUEST_PRODUCTS_LIST,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATALOG],
  },
  {
    title: "Requested Products",
    component: AddRequestProduct,
    route: APP_ROUTES.ADD_REQUEST_PRODUCT,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATALOG],
  },
  {
    title: "Requested Products",
    component: AddRequestProduct,
    route: APP_ROUTES.EDIT_REQUEST_PRODUCT,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_PRODUCT_CATALOG],
  },
  {
    title: "Notifications",
    component: NotificationList,
    route: "/notifications",
    sidebar: false,
    permissions: [],
  },
  {
    title: "Sales Analytics",
    // icon: salesManagementIcon,
    icon: SalesAnalyticsIcon,
    activeIcon: salesManagementActiveIcon,
    component: SalesAnalytics,
    route: APP_ROUTES.SALES_ANALYTICS,
    sidebar: true,
    hasSubRoutes: true,
    permissions: [PERMISSIONS.PERM_VIEW_SALES_ANALYTICS],
  },
  {
    title: "Sales Analytics",
    // icon: salesManagementIcon,
    icon: SalesAnalyticsIcon,
    activeIcon: salesManagementActiveIcon,
    component: SalesAnalytics,
    route: APP_ROUTES.SALES_ANALYTICS,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_SALES_ANALYTICS],
  },
  {
    title: "Campaigns",
    // icon: offerManagementIcon,
    icon: OfferIcon,
    activeIcon: offerManagementActiveIcon,
    component: OfferList,
    route: "/offerlist/discounts",
    sidebar: true,
    hasSubRoutes: true,
    permissions: [PERMISSIONS.PERM_VIEW_OFFER],
  },
  {
    title: "Offers",
    component: OfferList,
    route: "/offerlist/discounts",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_OFFER],
  },
  {
    title: "Offers",
    component: SubOfferView,
    route: APP_ROUTES.VIEW_SUBOFFER_OVERVIEW,
    subSidebar: false,
    permissions: [],
  },
  {
    title: "Offers",
    component: OfferHistory,
    route: APP_ROUTES.VIEW_OFFER_HISTORY_OVERVIEW,
    subSidebar: false,
    permissions: [],
  },
  {
    title: "Offers",
    component: SubOfferHistory,
    route: APP_ROUTES.VIEW_SUBOFFER_HISTORY_OVERVIEW,
    subSidebar: false,
    permissions: [],
  },
  {
    title: "Offers",
    // icon: offerManagementIcon,
    icon: OfferIcon,
    activeIcon: offerManagementActiveIcon,
    component: OfferList,
    route: "/offerlist/coupons",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_OFFER],
  },

  {
    title: "Offers",
    component: AddCoupon,
    route: "/add-coupon",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_OFFER],
  },
  {
    title: "Offers",
    component: AddCoupon,
    route: "/edit-coupon/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_OFFER],
  },
  {
    title: "Offers",
    component: ViewCoupon,
    route: "/coupon/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_OFFER],
  },
  {
    title: "Offers",
    component: DiscountView,
    route: "/discount-view/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_OFFER],
  },
  {
    title: "Offers",
    component: AddDiscount,
    route: APP_ROUTES.ADD_DISCOUNT,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_OFFER],
  },
  {
    title: "Offers",
    component: AddDiscount,
    route: APP_ROUTES.EDIT_DISCOUNT,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_OFFER],
  },
  {
    title: "Offers",
    component: AddDiscount,
    route: APP_ROUTES.CLONE_DISCOUNT,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_OFFER],
  },
  {
    title: "Offers",
    component: AddDiscount,
    route: APP_ROUTES.RESTART_DISCOUNT,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_OFFER],
  },
  {
    title: "Negative Items",
    component: NegativeItemList,
    route: APP_ROUTES.NEGATIVE_ITEMS_LIST,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_CUSTOMER_PLATFORM],
  },
  {
    title: "Negative Items",
    component: AddNegativeItem,
    route: APP_ROUTES.ADD_NEGATIVE_ITEM,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_CUSTOMER_PLATFORM],
  },
  {
    title: "Negative Items",
    component: AddNegativeItem,
    route: APP_ROUTES.EDIT_NEGATIVE_ITEM,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_CUSTOMER_PLATFORM],
  },
  {
    title: "Negative Items",
    component: NegativeItemView,
    route: APP_ROUTES.VIEW_NEGATIVE_ITEM,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_CUSTOMER_PLATFORM],
  },
  {
    title: "Negative Items",
    component: LinkNewItem,
    route: APP_ROUTES.LINKED_NEW_ITEM,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_CUSTOMER_PLATFORM],
  },
  {
    title: "Negative Items",
    component: EditLinkItem,
    route: APP_ROUTES.EDIT_LINK_ITEM,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_CUSTOMER_PLATFORM],
  },
  {
    title: "Negative Items",
    component: LinkNewVMNegativeitem,
    route: APP_ROUTES.LINKED_NEW_VM_NEGATIVE_ITEM,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_CUSTOMER_PLATFORM],
  },
  {
    title: "Negative Items",
    component: EditVMNegativeitem,
    route: APP_ROUTES.EDIT_LINK_VM_NEGATIVE_ITEM,
    subSidebar: false,
    permissions: [PERMISSIONS.PERM_CUSTOMER_PLATFORM],
  },

  {
    title: "Warehouse Management",
    component: TallyInventoryOverView,
    route: APP_ROUTES.TALLY_INVENTORY_OVERVIEW,
    // sidebar: false,
    subSidebar: false,
    permissions: [],
  },

  {
    title: "Warehouse Management",
    component: MaterialTransferOverview,
    route: APP_ROUTES.MATERIAL_TRANSFER_OVERVIEW,
    // sidebar: false,
    subSidebar: false,
    permissions: [],
  },

  {
    title: "Warehouse Management",
    component: MaterialTransferManageView,
    route: APP_ROUTES.MATERIAL_TRANSFER_MANAGE,
    // sidebar: false,
    subSidebar: false,
    permissions: [],
  },

  {
    title: "Warehouse Management",
    component: MaterialTransferEdit,
    route: APP_ROUTES.MATERIAL_TRANSFER_EDIT,
    // sidebar: false,
    subSidebar: false,
    permissions: [],
  },

  {
    title: "Warehouse Management",
    component: TransferOrderOverview,
    route: APP_ROUTES.VIEW_TRANSFER_ORDER,
    // sidebar: false,
    subSidebar: false,
    permissions: [],
  },

  {
    title: "Warehouse Management",
    component: RequestOrderOverview,
    route: APP_ROUTES.VIEW_REQUEST_ORDER,
    subSidebar: false,
    permissions: [],
  },

  {
    title: "Warehouse Management",
    component: DiscardedBinOverview,
    route: APP_ROUTES.DISCARDED_BIN_OVERVIEW,
    // sidebar: false,
    subSidebar: false,
    permissions: [],
  },

  {
    title: "Advertisements",
    icon: SalesAnalyticsIcon,
    activeIcon: salesManagementActiveIcon,
    component: AdvertisementList,
    route: APP_ROUTES.ADVERTISEMENT_MANAGEMENT,
    sidebar: true,
    hasSubRoutes: true,
    permissions: [PERMISSIONS.PERM_VIEW_ADVERTISEMENT],
  },
  {
    title: "Advertisements",
    // icon: salesManagementIcon,
    icon: SalesAnalyticsIcon,
    activeIcon: salesManagementActiveIcon,
    component: AdvertisementList,
    route: APP_ROUTES.ADVERTISEMENT_MANAGEMENT,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_ADVERTISEMENT],
  },
  {
    title: "Advertisements",
    component: AddAdvertisement,
    route: APP_ROUTES.ADD_ADVERTISEMENT,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_ADD_ADVERTISEMENT],
  },
  {
    title: "Advertisements",
    component: AddAdvertisement,
    route: APP_ROUTES.EDIT_ADVERTISEMENT,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_UPDATE_ADVERTISEMENT],
  },
  {
    title: "Advertisements",
    component: AdvertisementView,
    route: APP_ROUTES.VIEW_ADVERTISEMENT,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_ADVERTISEMENT],
  },
  //report module
  // {
  //   title: "Report",
  //   icon: CsvReportIcon,
  //   activeIcon: CsvReportIcon,
  //   component: ReportList,
  //   route: APP_ROUTES.REPORT,
  //   sidebar: true,
  //   // permissions: [],
  //   permissions: [PERMISSIONS.PERM_VIEW_FINANCE_REPORT],
  // },
  {
    title: "Ext. Sale Management",
    icon: SalePartnerIcon,
    activeIcon: SalePartnerIcon,
    component: ThirdPartySalesList,
    route: APP_ROUTES.THIRD_PARTY_SALES_LIST,
    sidebar: true,
    hasSubRoutes: true,
    permissions: [PERMISSIONS.PERM_CUSTOMER_PLATFORM],
  },
  {
    title: "Ext. Sale Partner",
    icon: SalePartnerIcon,
    activeIcon: SalePartnerIcon,
    component: ThirdPartySalesList,
    route: APP_ROUTES.THIRD_PARTY_SALES_LIST,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_CUSTOMER_PLATFORM],
  },
  {
    title: "Ext. Sale Partner",
    component: PlatformLinkedVMList,
    route: APP_ROUTES.PLATFORM_LINKED_VM_LIST,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_CUSTOMER_PLATFORM],
  },
  {
    title: "Ext. Sale Partner",
    component: VMRestrictedProductList,
    route: APP_ROUTES.VM_RESTRICTED_PRODUCT_LIST,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_CUSTOMER_PLATFORM],
  },

  {
    title: "PG Module",
    component: PgModuleOverview,
    route: "/pg-module",
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_PG_MODULE],
    // hasSubRoutes: true,
  },
  // Technician Partner
  {
    title: "Technician Partner",
    component: TechnicianPartnerList,
    route: APP_ROUTES.TECHNICIAN_PARTNER_LIST,
    sidebar: false,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_TECHNICIAN],
  },
  {
    title: "Technician Partner",
    component: AddTechnicalPartner,
    route: APP_ROUTES.TECHNICIAN_PARTNER_ADD,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_TECHNICIAN],
  },
  {
    title: "Technician Partner",
    component: AddTechnicalPartner,
    route: APP_ROUTES.TECHNICIAN_PARTNER_EDIT,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Technician Partner",
    component: TechnicianPartnerView,
    route: APP_ROUTES.TECHNICIAN_PARTNER_VIEW,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Technician Partner",
    component: TechnicianAddNewWarehouse,
    route: APP_ROUTES.TECHNICIAN_LINK_NEW_WAREHOUSE,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Technician Partner",
    component: TechnicianLinkNewVM,
    route: APP_ROUTES.TECHNICIAN_LINK_NEW_VM,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Technician Partner",
    component: TechnicianEditLinkVM,
    route: APP_ROUTES.TECHNICIAN_EDIT_LINK_VM,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Technician Partner",
    component: TechnicianLinkPermission,
    route: APP_ROUTES.LINK_TECHNICIAN_PERMISSION,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Technician Partner",
    component: TechnicianEditLinkPermission,
    route: APP_ROUTES.EDIT_LINK_TECHNICIAN_PERMISSION,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Technician Partner",
    component: TechnicianEditLinkNotification,
    route: APP_ROUTES.LINK_TECHNICIAN_NOTIFICATIONS,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Technician Partner",
    component: TechnicianEditLinkNotification,
    route: APP_ROUTES.EDIT_LINK_TECHNICIAN_NOTIFICATIONS,
    sidebar: false,
    permissions: [],
  },
  //technician Transaction
  {
    title: "Technician Management",
    icon: TechnicianTransactionIcon,
    activeIcon: TechnicianTransactionIcon,
    component: TechnicianPartnerList,
    route: APP_ROUTES.TECHNICIAN_PARTNER_LIST,
    sidebar: true,
    hasSubRoutes: true,
    permissions: [PERMISSIONS.PERM_VIEW_TECHNICIAN],
  },
  {
    title: "Technician Transaction List",
    icon: TechnicianTransactionIcon,
    activeIcon: TechnicianTransactionIcon,
    component: TechnicianTransactionList,
    route: APP_ROUTES.TECHNICIAN_TRANSACTION_LIST,
    sidebar: false,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_TECHNICIAN],
  },
  //
  {
    title: "Technician VM List",
    component: VmListTechnician,
    route: APP_ROUTES.TECHNICIAN_VM_LIST,
    sidebar: false,
    subSidebar: true,
    permissions: [PERMISSIONS.PERM_VIEW_TECHNICIAN],
  },
  {
    title: "Technician VM List",
    component: VendingMachineViewTechnician,
    route: APP_ROUTES.TECHNICIAN_VIEW_VM,
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_TECHNICIAN],
  },
  {
    title: "Technician VM List",
    component: VendingMachineSnapshot,
    route:  "/tech-vm-snapshot/:vmId",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_TECHNICIAN],
  },
   {
    title: "Vending Machine",
    component: DeletedVendingMachineView,
    route: "/tech-deletedVm/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_TECHNICIAN],
  },
  {
    title: "Technician VM List",
    component: CreateVendingMachine,
    route: APP_ROUTES.TECH_EDIT_VENDING_MACHINE,
    sidebar: false,
    permissions: [],
    // permissions: [PERMISSIONS.PERM_UPDATE_VENDING_MACHINE],
  },
  {
    title: "Technician VM List",
    component: CreateVendingMachine,
    route: APP_ROUTES.TECH_CREATE_VENDING_MACHINE,
    sidebar: false,
    permissions: [],

    // permissions: [PERMISSIONS.PERM_UPDATE_VENDING_MACHINE],
  },
  {
    title: "Technician VM List",
    component: FranchiseView,
    route: "/tech-franchise/:id",
    sidebar: false,
    permissions: [PERMISSIONS.PERM_VIEW_FRANCHISE],
  },
  {
    title: "Incident List",
    component: IncidentList,
    route: APP_ROUTES.GET_INCIDENT_LIST,
    sidebar: false,
    subSidebar: true,
    permissions: [],
  },
  {
    title: "Incident List",
    component: AddIncidentType,
    route: APP_ROUTES.INCIDENT_TYPE_ADD,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Incident List",
    component: AddIncident,
    route: APP_ROUTES.ADD_INCIDENT,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Job List",
    component: JobList,
    route: APP_ROUTES.GET_JOB_LIST,
    sidebar: false,
    subSidebar: true,
    permissions: [],
  },
  {
    title: "Job List",
    component: AddJob,
    route: APP_ROUTES.ADD_JOB,
    sidebar: false,
    permissions: [],
  },
  {
    title: "Job List",
    component: JobOverview,
    route: APP_ROUTES.VIEW_JOB,
    sidebar: false,
    permissions: [],
  },
  //Technician logs
  {
    title: "Technician Logs",
    component: TechnicianLogs,
    route: APP_ROUTES.TECHNICIAN_LOGS,
    sidebar: false,
    subSidebar: true,
    permissions: [],
  },
  //Motor Action logs
  {
    title: "Motor Action Logs",
    component: MotorActionLogs,
    route: APP_ROUTES.MOTOR_ACTION_LOGS,
    sidebar: false,
    subSidebar: true,
    permissions: [],
  },
  //  {
  //   title: "Action History",
  //   icon: ActionHistorySVG,
  //   activeIcon: ActionHistorySVG,
  //   component: ActionHistory,
  //   route: "/action-history",
  //   sidebar: true,
  //   hasSubRoutes: true,
  //   permissions: [],
  // },
  // {
  //   title: "Action History",
  //   component: ActionHistory,
  //   route: "/action-history",
  //   subSidebar: true,
  //   permissions: [],
  // },
  //  {
  //   title: "Action History",
  //   icon: SalePartnerIcon,
  //   activeIcon: SalePartnerIcon,
  //   component: ThirdPartySalesList,
  //   route: APP_ROUTES.THIRD_PARTY_SALES_LIST,
  //   subSidebar: true,
  //   permissions: [PERMISSIONS.PERM_CUSTOMER_PLATFORM],
  // },
];

// ROUTES[5]["subRoutes"] = [ROUTES[11], ROUTES[13], ROUTES[15], ROUTES[17]];

ROUTES[
  ROUTES.findIndex(
    (route) => route.title === "Product Catalog" && route.sidebar,
  )
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Product List" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Product Category" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Product Brand" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Product Unit" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Product Packaging" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Sync Product List" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "New Product List" && route.subSidebar,
    )
  ],
];

// ROUTES[
//   ROUTES.findIndex(
//     (route) => route.title === "Store Management" && route.sidebar
//   )
// ]["subRoutes"] = [
//   // ROUTES[
//   //   ROUTES.findIndex(
//   //     (route) => route.title === "Store Manager" && route.subSidebar
//   //   )
//   // ],
//   ROUTES[
//     ROUTES.findIndex(
//       (route) => route.title === "Shipping Management" && route.subSidebar
//     )
//   ],
// ];

ROUTES[
  ROUTES.findIndex(
    (route) => route.title === "Vending Machine" && route.sidebar,
  )
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex((route) => route.title === "VM List" && route.subSidebar)
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "VM Templates" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) =>
        route.title === "VM Board Setting Template" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Planogram Template" && route.subSidebar,
    )
  ],
];

ROUTES[
  ROUTES.findIndex(
    (route) => route.title === "Warehouse Management" && route.sidebar,
  )
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Warehouse List" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Supplier Management" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Procurement Management" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Warehouse Order" && route.subSidebar,
    )
  ],
];

ROUTES[
  ROUTES.findIndex((route) => route.title === "Transactions" && route.sidebar)
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Transaction History" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Direct Sales" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Requested Products" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Customer Feedback" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex((route) => route.title === "PG Module" && route.subSidebar)
  ],
];

ROUTES[
  ROUTES.findIndex(
    (route) => route.title === "Dashboard Management" && route.sidebar,
  )
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex((route) => route.title === "Dashboard" && route.subSidebar)
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "VM Analytics" && route.subSidebar,
    )
  ],
];

ROUTES[
  ROUTES.findIndex(
    (route) => route.title === "User Management" && route.sidebar,
  )
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex((route) => route.title === "User List" && route.subSidebar)
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Delivery Partner" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Refill Partner" && route.subSidebar,
    )
  ],
];

ROUTES[
  ROUTES.findIndex(
    (route) => route.title === "Inventory Management" && route.sidebar,
  )
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Inventory Management" && route.subSidebar,
    )
  ],
];

// ROUTES[
//   ROUTES.findIndex(
//     (route) => route.title === "Zone Management" && route.sidebar
//   )
// ]["subRoutes"] = [
//   ROUTES[
//     ROUTES.findIndex(
//       (route) => route.title === "Zone Management" && route.subSidebar
//     )
//   ],
// ];

// ROUTES[
//   ROUTES.findIndex(
//     (route) => route.title === "Delivery Partner" && route.sidebar
//   )
// ]["subRoutes"] = [
//   ROUTES[
//     ROUTES.findIndex(
//       (route) => route.title === "Delivery Partner" && route.subSidebar
//     )
//   ],
// ];

ROUTES[ROUTES.findIndex((route) => route.title === "Entity" && route.sidebar)][
  "subRoutes"
] = [
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Franchise Management" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex((route) => route.title === "Retailers" && route.subSidebar)
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Zone Management" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Store Management" && route.subSidebar,
    )
  ],
];

// ROUTES[
//   ROUTES.findIndex(
//     (route) => route.title === "Store Management" && route.sidebar
//   )
// ]["subRoutes"] = [
//   ROUTES[
//     ROUTES.findIndex(
//       (route) => route.title === "Store Management" && route.subSidebar
//     )
//   ],
// ];

// ROUTES[
//   ROUTES.findIndex((route) => route.title === "Refill Partner" && route.sidebar)
// ]["subRoutes"] = [
//   ROUTES[
//     ROUTES.findIndex(
//       (route) => route.title === "Refill Partner" && route.subSidebar
//     )
//   ],
// ];

// ROUTES[
//   ROUTES.findIndex((route) => route.title === "Retailers" && route.sidebar)
// ]["subRoutes"] = [
//   ROUTES[
//     ROUTES.findIndex((route) => route.title === "Retailers" && route.subSidebar)
//   ],
// ];

ROUTES[
  ROUTES.findIndex((route) => route.title === "Refill Plan" && route.sidebar)
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Refill Plan" && route.subSidebar,
    )
  ],
];
ROUTES[
  ROUTES.findIndex((route) => route.title === "Report Catalog" && route.sidebar)
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Report Catalog" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Generate Report" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Recurring Reports" && route.subSidebar,
    )
  ],
];

ROUTES[
  ROUTES.findIndex((route) => route.title === "System Auditor" && route.sidebar)
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Master Data Setup" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Vending Machines" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Refill Trigger" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Incident Trigger" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Planogram Adherence" && route.subSidebar,
    )
  ],
];

ROUTES[
  ROUTES.findIndex(
    (route) => route.title === "Sales Analytics" && route.sidebar,
  )
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Sales Analytics" && route.subSidebar,
    )
  ],
];

ROUTES[
  ROUTES.findIndex(
    (route) => route.title === "Ext. Sale Management" && route.sidebar,
  )
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Ext. Sale Partner" && route.subSidebar,
    )
  ],
];

ROUTES[
  ROUTES.findIndex((route) => route.title === "Campaigns" && route.sidebar)
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex((route) => route.title === "Offers" && route.subSidebar)
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Negative Items" && route.subSidebar,
    )
  ],
];

ROUTES[
  ROUTES.findIndex((route) => route.title === "Advertisements" && route.sidebar)
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Advertisements" && route.subSidebar,
    )
  ],
];
ROUTES[
  ROUTES.findIndex(
    (route) => route.title === "Technician Management" && route.sidebar
  )
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Technician VM List" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Technician Partner" && route.subSidebar,
    )
  ],
  // ROUTES[
  //   ROUTES.findIndex(
  //     (route) => route.title === "Technician Transaction List" && route.subSidebar
  //   )
  // ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Incident List" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex((route) => route.title === "Job List" && route.subSidebar)
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Technician Logs" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Motor Action Logs" && route.subSidebar,
    )
  ],
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "VM Template List" && route.subSidebar,
    )
  ],

];

// ROUTES[
//   ROUTES.findIndex(
//     (route) => route.title === "Action History" && route.sidebar
//   )
// ]["subRoutes"] = [
//   ROUTES[
//     ROUTES.findIndex(
//       (route) => route.title === "Action History" && route.subSidebar
//     )
//   ],
// ];

// Machines Module
ROUTES.push({
  title: "Machine Operations Center",
  icon: EventModuleIcon,
  activeIcon: EventModuleIcon,
  component: MachineEventLog,
  route: APP_ROUTES.MACHINE_EVENT_LOG,
  sidebar: true,
  hasSubRoutes: true,
  permissions: [PERMISSIONS.PERM_VIEW_MACHINE_EVENT_LOG],
});

ROUTES.push({
  title: "Machine Communication Log",
  component: MachineEventLog,
  route: APP_ROUTES.MACHINE_EVENT_LOG,
  subSidebar: true,
  permissions: [PERMISSIONS.PERM_VIEW_MACHINE_EVENT_LOG],
});

ROUTES[
  ROUTES.findIndex(
    (route) => route.title === "Machine Operations Center" && route.sidebar
  )
]["subRoutes"] = [
  ROUTES[
    ROUTES.findIndex(
      (route) => route.title === "Machine Communication Log" && route.subSidebar,
    )
  ],
];

export default ROUTES;
